import { TextField, TextFieldProps } from '@mui/material';
import { FieldProps, useField } from 'formik';
import { ChangeEventHandler, FC, FocusEventHandler } from 'react';
import styled from 'styled-components';

type InputFieldProps = FieldProps &
  TextFieldProps & {
    submitOnBlur?: boolean;
    submitOnChange?: boolean;
    onBlur?: FocusEventHandler;
    onChange?: ChangeEventHandler<HTMLInputElement>;
  };

export const InputField: FC<InputFieldProps> = ({
  field,
  form,
  select,
  submitOnBlur = true,
  submitOnChange = select,
  helperText,
  onBlur,
  onChange,
  onPaste,
  ...restProps
}) => {
  const [, meta] = useField(field.name);

  return (
    <StyledTextField
      size="small"
      error={Boolean(meta.error)}
      select={select}
      {...field}
      {...restProps}
      helperText={meta.error || helperText}
      onBlur={(event) => {
        field.onBlur(event);

        if (!select && submitOnBlur) {
          form.submitForm();
        }

        onBlur?.(event);
      }}
      onChange={(event) => {
        field.onChange(event);

        onChange?.(event);

        if (submitOnChange) {
          form.submitForm();
        }
      }}
      onPaste={onPaste}
    />
  );
};

const StyledTextField = styled(TextField)`
  min-width: 290px;
`;
